import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '/api';

export default function SlotPicker({ serviceId, serviceIds, selectedDate, selectedTime, onDateChange, onTimeChange, language, t }) {
  const [availableTimes, setAvailableTimes] = useState([]);
  const [loadingTimes, setLoadingTimes] = useState(false);
  const [businessHours, setBusinessHours] = useState([]);
  const [dateError, setDateError] = useState('');

  // Support both serviceIds array and single serviceId (backward compat)
  const resolvedIds = serviceIds && serviceIds.length > 0 ? serviceIds : (serviceId ? [serviceId] : []);

  useEffect(() => {
    axios.get(`${API}/schedule/hours`).then(r => setBusinessHours(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (resolvedIds.length > 0 && selectedDate) {
      setLoadingTimes(true);
      setAvailableTimes([]);
      onTimeChange('');
      const params = { date: selectedDate };
      if (resolvedIds.length === 1) {
        params.service_id = resolvedIds[0];
      } else {
        params.service_ids = resolvedIds.join(',');
      }
      axios.get(`${API}/appointments/availability`, { params })
        .then(r => setAvailableTimes(r.data.available_times || []))
        .catch(() => setAvailableTimes([]))
        .finally(() => setLoadingTimes(false));
    }
    // eslint-disable-next-line
  }, [JSON.stringify(resolvedIds), selectedDate]);

  const getMinDate = () => new Date().toISOString().split('T')[0];

  const isPastDate = (dateStr) => {
    if (!dateStr) return false;
    return dateStr < getMinDate();
  };

  const isClosedDay = (dateStr) => {
    if (!dateStr || businessHours.length === 0) return false;
    const date = new Date(dateStr + 'T12:00:00');
    const dayOfWeek = date.getDay();
    const dayHours = businessHours.find(h => h.day_of_week === dayOfWeek);
    return dayHours?.is_closed ?? false;
  };

  const handleDateChange = (val) => {
    setDateError('');
    if (isPastDate(val)) {
      setDateError(t.booking.pastDateError || 'You cannot select a past date.');
      return;
    }
    if (isClosedDay(val)) {
      setDateError(t.booking.closedDayError);
      onDateChange(val);
      return;
    }
    onDateChange(val);
  };

  return (
    <div>
      <div className="mb-3">
        <label className="form-label">{t.booking.dateLabel}</label>
        <input type="date" min={getMinDate()} value={selectedDate}
          onChange={e => handleDateChange(e.target.value)}
          className="form-control"
          style={{ colorScheme: 'dark' }}
        />
        {dateError && (
          <div className="alert alert-warning mt-2" style={{ fontSize: '0.85rem' }}>
            {dateError}
          </div>
        )}
      </div>
      <div className="mb-3">
        <label className="form-label">{t.booking.timeLabel}</label>
        {loadingTimes ? (
          <div style={{ color: '#D42B2B', padding: '1rem', textAlign: 'center', fontSize: '0.85rem' }}>
            {t.booking.loadingTimes}
          </div>
        ) : !selectedDate ? (
          <div style={{ color: '#94A3B8', padding: '1rem', textAlign: 'center', fontSize: '0.85rem' }}>
            {t.booking.dateLabel}
          </div>
        ) : availableTimes.length === 0 && !dateError ? (
          <div className="alert alert-warning">
            {t.booking.noAvailableTimes}
          </div>
        ) : (
          <div className="cjpa-time-grid">
            {availableTimes.map(time => (
              <button key={time} type="button" onClick={() => onTimeChange(time)} style={{
                background: selectedTime === time ? '#D42B2B' : 'transparent',
                border: '1px solid ' + (selectedTime === time ? '#D42B2B' : 'rgba(148,163,184,0.25)'),
                color: selectedTime === time ? '#0C1220' : '#94A3B8',
                padding: '0.7rem', fontFamily: "'Barlow', sans-serif",
                fontSize: '0.75rem', cursor: 'pointer', transition: 'all 0.2s', letterSpacing: '0.05em', fontWeight: 500,
              }}>{time}</button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
